import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiHint } from '@taiga-ui/core';
import { TuiBadge, TuiBadgedContent, TuiBadgeNotification } from '@taiga-ui/kit';
import { TranslateModule } from '@ngx-translate/core';
import { NewListModule } from '@src/app/modules/list';
import { IconModule } from '@src/app/modules/icon';

import { PagesListItemComponent } from './components';
import { PagesService } from './services';

@NgModule({
  declarations: [PagesListItemComponent],
  imports: [
    CommonModule,
    NewListModule,
    IconModule,
    ...TuiHint,
    ...TuiBadgedContent,
    TuiBadge,
    TuiBadgeNotification,
    TranslateModule,
  ],
  providers: [PagesService],
  exports: [PagesListItemComponent],
})
export class PagesModule {}
